import { Input, Form } from 'antd';
import { FC, useState } from 'react';
import { footerReducer } from '../../../antd-reducer/footer-reducer';
import { obtenerIcono } from '../../util/AppIcons';
import './FollowUs.less';

const validateMessages = {
    required: 'Email requerido',
    types: {
      email: 'Email incorrecto'
    }
};

export const FollowUs:FC<{}> = (props) => {

    const [focus, setFocus] = useState(false);
    const [hover, setHover] = useState(false);

    return (
    <div className='follow-us'>
        <p className='title'>SÍGUENOS</p>
        <p className='subtitle'>Suscríbete y recibe nuestras ofertas</p>
        <div className='text-field'>
            <label
                htmlFor="email"
                className={focus ? 'label-focus' : hover ? 'label-hover' : ''}
            >
                Email
            </label>
            <div className="label-container"></div>

            <Form
                name="nest-messages"
                validateMessages={validateMessages}
            >
                <Form.Item
                    name={['email', 'required']}
                    rules={[{required: true}, { type: 'email' }]}
                    hasFeedback
                >
                    <Input
                        id='email'
                        placeholder="Ingresa un email"
                        suffix={obtenerIcono('icon-send-footer')}
                        onBlur={() => setFocus(false)}
                        onFocus={() => setFocus(true)}
                        onMouseLeave={() => setHover(false)}
                        onMouseEnter={() => setHover(true)}
                    ></Input>
                </Form.Item>
            </Form>
        </div>

        <div className='icons'>
            {
                footerReducer.socialMedia.map(({ key, icon, url }) => {
                    return (
                    <div className='icon' key={key}>
                        <a href={url}>
                            { obtenerIcono(`icon-${icon}-footer`) }
                        </a>
                    </div>
                    )
                })
            }
        </div>
    </div>
    )
}